import { motion } from "framer-motion";
import { UserContext } from "../../UserContext";
import { useContext } from "react";
import { SignOutButton } from "../../../msal-login/msal-login-buttons/SignOutButton";
import { PowerIcon } from "@heroicons/react/24/outline";

export default function MSLogoutModal({ onClose }) {
  const { darkTheme } = useContext(UserContext);

  return (
    <motion.div
      initial={{ opacity: 0, y: 15, scale: 0.96 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 15, scale: 0.96 }}
      transition={{ type: "spring", stiffness: 300, damping: 26 }}
      className={`w-72 md:w-80 m-2 px-6 py-6 rounded-2xl shadow-2xl border ${
        darkTheme ? "bg-DarkGray border-White/10" : "bg-White border-Border"
      }`}
      onClick={(e) => e.stopPropagation()}
    >
      <div className={`flex items-center flex-col text-center`}>
        <div
          className="flex items-center justify-center w-11 h-11 rounded-full mb-3 bg-BoldRed/10 text-BoldRed"
        >
          <PowerIcon className="w-5 h-5" />
        </div>
        <h3
          className={`text-base font-semibold ${
            darkTheme ? "text-White" : "text-Text"
          }`}
        >
          Sign out?
        </h3>
        <p
          className={`mt-1.5 text-[13.5px] leading-relaxed ${
            darkTheme ? "text-[#c3c3c3]" : "text-[#5b5b5b]"
          }`}
        >
          You'll need to sign in again to access your account.
        </p>
        <div className={`flex items-center gap-3 mt-6 w-full`}>
          <SignOutButton variant="button" onSignOut={onClose} />
          <button
            onClick={onClose}
            className={`flex-1 py-2 rounded-full text-sm font-medium transition-all active:scale-[0.97] ${
              darkTheme
                ? "bg-transparent border border-White/15 text-White hover:bg-White/5"
                : "bg-transparent border border-Border text-Text hover:bg-Bg"
            }`}
          >
            Cancel
          </button>
        </div>
      </div>
    </motion.div>
  );
}
